const KEY = "shieldpilot.history.v1";
const MAX = 25;
const VERIFY_KEY = (domain) => `shieldpilot.verify.${domain.toLowerCase()}`;

export function loadHistory() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveScan(scan) {
  const list = loadHistory();
  const next = [scan, ...list.filter((s) => s.id !== scan.id)].slice(0, MAX);
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
}

export function getScan(id) {
  return loadHistory().find((s) => s.id === id) || null;
}

export function clearHistory() {
  localStorage.removeItem(KEY);
}

export function removeScan(id) {
  const next = loadHistory().filter((s) => s.id !== id);
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
}

// ---------- Verification tokens (per-domain) ----------

// Shape: { challengeId, token, challengeExpiresAt, verified, scanToken, scanTokenExpiresAt }
// Expired entries are dropped on load so the UI never shows a stale "verified" state.
export function loadVerification(domain) {
  if (!domain) return null;
  try {
    const raw = localStorage.getItem(VERIFY_KEY(domain));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.challengeId !== "string") {
      clearVerification(domain);
      return null;
    }
    const expiry = parsed.verified ? parsed.scanTokenExpiresAt : parsed.challengeExpiresAt;
    if (!expiry || Date.parse(expiry) <= Date.now() || (parsed.verified && !parsed.scanToken)) {
      clearVerification(domain);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function saveVerification(domain, data) {
  if (!domain) return;
  localStorage.setItem(VERIFY_KEY(domain), JSON.stringify(data));
}

export function clearVerification(domain) {
  if (!domain) return;
  localStorage.removeItem(VERIFY_KEY(domain));
}
